import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

// modules
import {MaterialModule} from "../shared/material/material.module";
import {SharedModule} from "../shared/shared.module";

// guard
import {authGuard} from "../shared/guard/auth.guard";

// components
import {SidenavMenuComponent} from './components/sidenav-menu/sidenav-menu.component';
import {SidenavToolbarComponent} from './components/sidenav-toolbar/sidenav-toolbar.component';
import {ServiceOrderFormComponent} from './service-orders/service-order-form/service-order-form.component';
import {ServiceOrderSaveComponent} from './service-orders/service-order-save/service-order-save.component';
import {ServiceOrdersListComponent} from './service-orders/service-orders-list/service-orders-list.component';
import {
    ServiceOrderStatusColorComponent
} from './service-orders/components/service-order-status-color/service-order-status-color.component';
import {
    ServiceOrderMessageComponent
} from './service-orders/components/service-order-message/service-order-message.component';
import {
    ServiceOrderSaveButtonComponent
} from './service-orders/components/service-order-save-button/service-order-save-button.component';
import {
    ServiceOrderStatusEditComponent
} from './service-orders/components/service-order-status-edit/service-order-status-edit.component';
import {
    ServiceOrderStatusEditButtonComponent
} from './service-orders/components/service-order-status-edit-button/service-order-status-edit-button.component';
import {ChatMessageModalComponent} from './service-orders/components/chat-message-modal/chat-message-modal.component';
import {
    WorkingTimeSaveButtonComponent
} from './working-times/components/working-time-save-button/working-time-save-button.component';
import {WaterMeterFormComponent} from './water-protocol/water-meter-form/water-meter-form.component';
import {WaterMeterComponent} from './water-protocol/components/water-meter/water-meter.component';
import {DeleteModalComponent} from './components/delete-modal/delete-modal.component';
import {
    ServiceOrderImagesFormComponent
} from './service-order-images/service-order-images-form/service-order-images-form.component';
import {ImageViewModalComponent} from './components/image-view-modal/image-view-modal.component';
import {ImageCardComponent} from './service-order-images/image-card/image-card.component';
import {FormSaveButtonComponent} from './components/form-save-button/form-save-button.component';
import {UserFormComponent} from './users/user-form/user-form.component';
import {DashboardCardComponent} from './dashboard/dashboard-card/dashboard-card.component';
import {DepositsListComponent} from './deposits/deposits-list/deposits-list.component';
import {DepositFormComponent} from './deposits/deposit-form/deposit-form.component';
import {DepositShowComponent} from './deposits/deposit-show/deposit-show.component';
import {DepositSaveComponent} from './deposits/deposit-save/deposit-save.component';
import {DepositUpdateComponent} from './deposits/deposit-update/deposit-update.component';
import {DepositCompletedModalComponent} from './deposits/deposit-completed-modal/deposit-completed-modal.component';
import {CommentModalComponent} from './service-orders/components/comment-modal/comment-modal.component';
import {
    ServiceOrderCommentComponent
} from './service-orders/components/service-order-comment/service-order-comment.component';
import {CommentFormComponent} from './service-orders/components/comment-form/comment-form.component';
import {
    ServiceOrderInvoiceUpdateComponent
} from './service-orders/components/service-order-invoice-update/service-order-invoice-update.component';
import {
    ServiceOrderInvoiceFormComponent
} from './service-orders/components/service-order-invoice-form/service-order-invoice-form.component';


// secure pages
import {SecureComponent} from './secure.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ServiceOrdersComponent} from './service-orders/service-orders.component';
import {ServiceOrderComponent} from './service-orders/service-order/service-order.component';
import {ServiceOrdersCurrentComponent} from './service-orders/service-orders-current/service-orders-current.component';
import {ServiceOrdersInvoiceComponent} from './service-orders/service-orders-invoice/service-orders-invoice.component';
import {ServiceOrdersArchiveComponent} from './service-orders/service-orders-archive/service-orders-archive.component';
import {UsersComponent} from './users/users.component';
import {ProfileComponent} from './profile/profile.component';
import {UsersListComponent} from './users/users-list/users-list.component';
import {WorkingTimesComponent} from './working-times/working-times.component';
import {WorkingTimesListComponent} from './working-times/working-times-list/working-times-list.component';
import {WorkingTimeShowComponent} from './working-times/working-time-show/working-time-show.component';
import {WorkingTimeSaveComponent} from './working-times/working-time-save/working-time-save.component';
import {WorkingTimeFormComponent} from './working-times/working-time-form/working-time-form.component';
import {WorkingTimeUpdateComponent} from './working-times/working-time-update/working-time-update.component';
import {WaterProtocolComponent} from './water-protocol/water-protocol.component';
import {WaterProtocolSaveComponent} from './water-protocol/water-protocol-save/water-protocol-save.component';
import {WaterProtocolFormComponent} from './water-protocol/water-protocol-form/water-protocol-form.component';
import {ServiceOrderImagesComponent} from './service-order-images/service-order-images.component';
import {
    ServiceOrderImagesSaveComponent
} from './service-order-images/service-order-images-save/service-order-images-save.component';
import {
    ServiceOrderAddressEditComponent
} from './service-orders/service-order-address-edit/service-order-address-edit.component';
import {AddressFormComponent} from './service-orders/service-order-address-edit/address-form/address-form.component';
import {
    ServiceOrderCompletedModalComponent
} from './service-orders/components/service-order-completed-modal/service-order-completed-modal.component';
import {IntercomCodesComponent} from './intercom-codes/intercom-codes.component';
import {IntercomCodesListComponent} from './intercom-codes/intercom-codes-list/intercom-codes-list.component';
import {IntercomCodeFormComponent} from './intercom-codes/intercom-code-form/intercom-code-form.component';
import {IntercomCodeSaveComponent} from './intercom-codes/intercom-code-save/intercom-code-save.component';
import {IntercomCodeUpdateComponent} from './intercom-codes/intercom-code-update/intercom-code-update.component';
import {
    IntercomCodeShowModalComponent
} from './intercom-codes/intercom-code-show-modal/intercom-code-show-modal.component';
import {WaterMeterUpdateComponent} from './water-protocol/water-meter-update/water-meter-update.component';
import {UserShowComponent} from './users/user-show/user-show.component';
import {DepositsComponent} from './deposits/deposits.component';
import {DepositsCurrentComponent} from './deposits/deposits-current/deposits-current.component';
import {DepositsArchiveComponent} from './deposits/deposits-archive/deposits-archive.component';
import {CarsComponent} from './cars/cars.component';
import {CarsCurrentComponent} from './cars/cars-current/cars-current.component';
import {CarsListComponent} from './cars/cars-list/cars-list.component';
import {CarsArchiveComponent} from './cars/cars-archive/cars-archive.component';
import {CarCompletedModalComponent} from './cars/car-completed-modal/car-completed-modal.component';
import {CarFormComponent} from './cars/car-form/car-form.component';
import {CarSaveComponent} from './cars/car-save/car-save.component';
import {CarShowComponent} from './cars/car-show/car-show.component';
import {CarUpdateComponent} from './cars/car-update/car-update.component';
import {TasksComponent} from './tasks/tasks.component';
import {TaskCompletedModalComponent} from './tasks/task-completed-modal/task-completed-modal.component';
import {TaskFormComponent} from './tasks/task-form/task-form.component';
import {TaskSaveComponent} from './tasks/task-save/task-save.component';
import {TaskShowComponent} from './tasks/task-show/task-show.component';
import {TaskUpdateComponent} from './tasks/task-update/task-update.component';
import {TasksArchiveComponent} from './tasks/tasks-archive/tasks-archive.component';
import {TasksCurrentComponent} from './tasks/tasks-current/tasks-current.component';
import {TasksListComponent} from './tasks/tasks-list/tasks-list.component';
import {TaskStatusModalComponent} from './tasks/task-status-modal/task-status-modal.component';
import {TaskStatusColorComponent} from './tasks/components/task-status-color/task-status-color.component';
import { TaskPriorityColorComponent } from './tasks/components/task-priority-color/task-priority-color.component';


const routes: Routes = [

    // secure pages
    {
        path: '',
        component: SecureComponent,
        canActivate: [authGuard],
        children: [
            {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
            {path: 'dashboard', component: DashboardComponent, title: "Panel"},
            {path: 'service-order-add', component: ServiceOrderSaveComponent, title: "Dodanie zgłoszenia"},
            {path: 'service-order-add/:id', component: ServiceOrderSaveComponent, title: "Dodanie zgłoszenia"},
            {path: 'service-orders', component: ServiceOrdersCurrentComponent, title: "Zgłoszenia serwisowe"},
            {path: 'service-orders-invoice', component: ServiceOrdersInvoiceComponent, title: "Rozliczanie zgłoszeń"},
            {path: 'service-orders-archive', component: ServiceOrdersArchiveComponent, title: "Archiwum zgłoszeń"},
            {path: 'address-edit/:id', component: ServiceOrderAddressEditComponent, title: "Edycja adresu"},
            {path: 'service-order/:id', component: ServiceOrderComponent, title: "Zgłoszenie serwisowe"},
            {path: 'service-order-images/:id', component: ServiceOrderImagesComponent, title: "Zdjęcia"},
            {
                path: 'service-order-images-add/:id',
                component: ServiceOrderImagesSaveComponent,
                title: "Dodanie zdjęcia"
            },
            {path: 'water-protocol-add/:id', component: WaterProtocolSaveComponent, title: "Protokół wodny"},
            {path: 'water-protocol/:id', component: WaterProtocolComponent, title: "Protokół wodny"},
            {path: 'water-meter-update/:id', component: WaterMeterUpdateComponent, title: "Aktualizacja licznika"},
            {path: 'intercom-code-add', component: IntercomCodeSaveComponent, title: "Dodanie kodu"},
            {path: 'intercom-code-update/:id', component: IntercomCodeUpdateComponent, title: "Aktualizacja kodu"},
            {path: 'intercom-codes', component: IntercomCodesComponent, title: "Kody domofonów"},
            {path: 'deposit-show/:id', component: DepositShowComponent, title: "Depozyt"},
            {path: 'deposit-add', component: DepositSaveComponent, title: "Dodanie depozytu"},
            {path: 'deposit-update/:id', component: DepositUpdateComponent, title: "Aktualizacja depozytu"},
            {path: 'deposits', component: DepositsCurrentComponent, title: "Depozyty"},
            {path: 'deposits-archive', component: DepositsArchiveComponent, title: "Depozyty archiwalne"},
            {path: 'car-show/:id', component: CarShowComponent, title: "Samochód"},
            {path: 'car-add', component: CarSaveComponent, title: "Dodanie samochodu"},
            {path: 'car-update/:id', component: CarUpdateComponent, title: "Aktualizacja samochodu"},
            {path: 'cars', component: CarsCurrentComponent, title: "Samochody"},
            {path: 'cars-archive', component: CarsArchiveComponent, title: "Samochody archiwalne"},
            {path: 'task-show/:id', component: TaskShowComponent, title: "Zadanie"},
            {path: 'task-update/:id', component: TaskUpdateComponent, title: "Aktualizacja zadania"},
            {path: 'task-add', component: TaskSaveComponent, title: "Dodanie zadania"},
            {path: 'tasks', component: TasksCurrentComponent, title: "Zadania"},
            {path: 'tasks-archive', component: TasksArchiveComponent, title: "Zadania archiwalne"},
            {path: 'working-time-add', component: WorkingTimeSaveComponent, title: "Dodanie czasu pracy"},
            {path: 'working-time-update/:id', component: WorkingTimeUpdateComponent, title: "Aktualizacja czasu pracy"},
            {path: 'working-time-show/:id', component: WorkingTimeShowComponent, title: "Czas pracy"},
            {path: 'working-times', component: WorkingTimesComponent, title: "Czasy pracy"},
            {path: 'user-show/:id', component: UserShowComponent, title: "Informacje profilowe"},
            {path: 'users', component: UsersComponent, title: "Użytkownicy"},
            {path: 'profile', component: ProfileComponent, title: "Profil"}
        ]
    }
];

@NgModule({
    declarations: [
        SecureComponent,
        DashboardComponent,
        ProfileComponent,
        SidenavMenuComponent,
        SidenavToolbarComponent,
        ServiceOrdersComponent,
        ServiceOrderFormComponent,
        ServiceOrderSaveComponent,
        ServiceOrdersListComponent,
        ServiceOrderStatusColorComponent,
        ServiceOrderComponent,
        ServiceOrderMessageComponent,
        ServiceOrderSaveButtonComponent,
        ServiceOrderStatusEditComponent,
        ServiceOrderStatusEditButtonComponent,
        ChatMessageModalComponent,
        UsersComponent,
        UsersListComponent,
        WorkingTimesComponent,
        WorkingTimesListComponent,
        WorkingTimeSaveComponent,
        WorkingTimeFormComponent,
        WorkingTimeSaveButtonComponent,
        WorkingTimeUpdateComponent,
        WaterProtocolComponent,
        WaterProtocolSaveComponent,
        WaterProtocolFormComponent,
        WaterMeterFormComponent,
        WaterMeterComponent,
        DeleteModalComponent,
        ServiceOrderImagesComponent,
        ServiceOrderImagesSaveComponent,
        ServiceOrderImagesFormComponent,
        ImageViewModalComponent,
        ImageCardComponent,
        ServiceOrderAddressEditComponent,
        AddressFormComponent,
        ServiceOrdersCurrentComponent,
        ServiceOrdersArchiveComponent,
        ServiceOrderCompletedModalComponent,
        WorkingTimeShowComponent,
        IntercomCodesComponent,
        IntercomCodesListComponent,
        IntercomCodeFormComponent,
        IntercomCodeSaveComponent,
        IntercomCodeUpdateComponent,
        FormSaveButtonComponent,
        IntercomCodeShowModalComponent,
        WaterMeterUpdateComponent,
        UserShowComponent,
        UserFormComponent,
        DashboardCardComponent,
        DepositsComponent,
        DepositsListComponent,
        DepositFormComponent,
        DepositShowComponent,
        DepositSaveComponent,
        DepositUpdateComponent,
        DepositCompletedModalComponent,
        DepositsCurrentComponent,
        DepositsArchiveComponent,
        CommentModalComponent,
        ServiceOrderCommentComponent,
        CommentFormComponent,
        ServiceOrdersInvoiceComponent,
        ServiceOrderInvoiceUpdateComponent,
        ServiceOrderInvoiceFormComponent,
        CarsComponent,
        CarsCurrentComponent,
        CarsListComponent,
        CarsArchiveComponent,
        CarCompletedModalComponent,
        CarFormComponent,
        CarSaveComponent,
        CarShowComponent,
        CarUpdateComponent,
        TasksComponent,
        TaskCompletedModalComponent,
        TaskFormComponent,
        TaskSaveComponent,
        TaskShowComponent,
        TaskUpdateComponent,
        TasksArchiveComponent,
        TasksCurrentComponent,
        TasksListComponent,
        TaskStatusModalComponent,
        TaskStatusColorComponent,
        TaskPriorityColorComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        NgOptimizedImage,
        MaterialModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class SecureModule {
}
